@if (runState() === 'done' && hasContent()) {
  <rt-button
    class="summary"
    [class.summary--expanded]="expanded()"
    variant="plain"
    size="small"
    (click)="toggle()"
  >
    <rt-icon class="chev" name="expand-more" />
    <span>{{ summaryKey() | translate: { count: toolCount() } }}</span>
  </rt-button>
}

@if (expanded() && hasContent()) {
  <div class="timeline">
    @let shimmer = showThinkingShimmer();
    @for (event of timeline(); track $index) {
      @switch (event.kind) {
        @case ('reasoning') {
          <tellent-assistant-text-part
            class="reasoning"
            [content]="event.content"
            [done]="event.done"
          />
        }
        @case ('tool') {
          <div
            class="row"
            [class.row--running]="event.status === 'running'"
            [class.row--error]="event.status === 'error'"
          >
            @switch (event.status) {
              @case ('done') {
                <rt-icon
                  class="ico ok"
                  name="check"
                  size="small"
                  colorToken="colorGradientAiStrongDefault"
                />
              }
              @case ('running') {
                <tellent-assistant-brand-mark class="ico brand" />
              }
              @case ('error') {
                <rt-icon class="ico err" name="close" size="small" />
              }
            }
            <span class="name">{{ event.name }}</span>
          </div>
        }
      }
    }
    @if (shimmer) {
      <tellent-assistant-thinking-indicator />
    }
  </div>
}
